import axios from "axios";
import axios_base_chat from "../axios_base_chat";
import i18n from "../i18n";
import { capitalizeFirstLetter } from "../Utils/stringHelpers";
import { saveOptimisticMessage } from "./optimisticMessages.js";

export async function send(content: any, type: any, chat: any, departamrnt: any, token: any, sign: any, operatorName?: string) {
    var data = new FormData();
    data.append("content", content);
    data.append("content_type", type);
    data.append("signature", sign);


    try {
        const response = await axios.request({
            method: "POST",
            url: `${process.env.REACT_APP_LINK_API}/chat/department/${departamrnt}/attendance/${chat}/message`,
            headers: {
                "Content-Type": "multipart/form-data; boundary=---011000010111000001101001",
                Authorization: `Bearer ${token}`,
            },
            data: data,
        });

        if (response.status >= 200 && response.status < 300) {
            
            const operator = operatorName || chat?.operator || capitalizeFirstLetter(i18n.t('words.operator'));
            const optimisticMessage = saveOptimisticMessage(content, type, chat, departamrnt, sign, operator);

            return {
                ...response,
                optimisticMessage
            };
        }     
        
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        
    } catch (error) {
        throw error;
    }
}

export function get(sectorID: Number, attendanceId: Number, limit: Number) {
    axios_base_chat.get(`/chat/department/${sectorID}/attendance/${attendanceId}/message?limit=${limit}`)
        .then(res => {
            return (res.data);
        })
        .catch(err => {
        });
}